import { DateTime } from 'luxon';
import { getI18n } from 'react-i18next';
import { ChatMessageTimeProps } from './types';

export const ChatMessageTime = ({ time }: ChatMessageTimeProps) => {
    const date = DateTime.fromISO(time).toLocal().setLocale(getI18n().language);
    const formatted = date.toFormat('t');
    return <span className="text-xs pl-2">{formatted}</span>;
};
